import { AxiosPromise } from 'axios';
import { getAxiosInstance } from 'Utils/Http/ApiManager';
import { ApiUrl, getApiUrl } from 'Utils/Http/ApiUrls';

const deleteVideoRequest = (token: string | null, videoId: number): AxiosPromise => {
	const url = getApiUrl(ApiUrl.VideosVideo).replace(':videoId', videoId.toString());
	const axiosInstance = getAxiosInstance(token);
	return axiosInstance.delete(url);
};

export default deleteVideoRequest;
